import { Checkbox } from "@chakra-ui/react";
import React from "react";
import { COMMON_WEB_PATH } from "../../../constant";

const CustomCheckbox = (props) => {
  return (
    <Checkbox
      {...props}
      sx={{
        "& .chakra-checkbox__control": {
          bg: `url(${COMMON_WEB_PATH}/now888/signIn/checkbox_background.png)`,
          border: "none",
          backgroundImage: `url(${COMMON_WEB_PATH}/now888/signIn/checkbox_background.png)`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          width: "25px",
          height: "25px",
          _checked: {
            bg: `url(${COMMON_WEB_PATH}/now888/signIn/checkbox_background.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            width: "25px",
            height: "25px",
            "& div": {
              backgroundImage: `url(${COMMON_WEB_PATH}/now888/signIn/checkbox_tick.png)`,
              w: "100%",
              bgRepeat: "no-repeat",
              bgSize: "contain",
            },
            "& svg": {
              display: "none",
            },
          },
        },
      }}
    >
      {props.labelText}
    </Checkbox>
  );
};

export default CustomCheckbox;
